<template>
  <div class="real-estate">
    <div class="real-estate-back">
      <create-header :need-back-txt="false"></create-header>
    </div>
    <div class="real-estate-main">
      <mk-tabs-biz
        v-model="activeName"
        class="el-tabs-mk-ui"
      >
        <mk-tab-pane
          v-for="(tab, index) in tabs"
          :key="index"
          :label="tab.label"
          :name="tab.name"
        >
        </mk-tab-pane>
      </mk-tabs-biz>
    </div>
    <div
      v-if="activeName"
      class="real-estate-pane"
    >
      <component :is="activeName" />
    </div>
  </div>
</template>

<script>
import CreateHeader from '@/components/create-header'
import BaseStatistics from './components/base-statistics'
import FormDetail from './components/form-detail'
export default {
  name: 'RealEstate',
  components: {
    CreateHeader,
    BaseStatistics,
    FormDetail
  },
  data () {
    return {
      activeName: 'base-statistics',
      tabs: [{
        label: '基础统计',
        name: 'base-statistics'
      },
      {
        label: '表单明细',
        name: 'form-detail'
      }]
    }
  },
  activated () {
    this.activeName = 'base-statistics'
  },
  deactivated () {
    this.activeName = ''
  }
}
</script>

<style lang="scss">
.real-estate-pane {
  margin: 16px 20px;
}
</style>
